import * as React from 'react';

function SvgCommissionAdd(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={34} height={33} {...props}>
      <path
        fill="#38B2A6"
        fillRule="evenodd"
        d="M17.124 0c9.052 0 16.391 7.351 16.391 16.42 0 9.068-7.339 16.419-16.391 16.419-9.053 0-16.392-7.351-16.392-16.42C.732 7.352 8.071 0 17.124 0zm.91 7.298h-2.732v7.753h-7.74v2.737l7.74-.001v7.754h2.732v-7.754h7.74v-2.736h-7.74V7.298z"
      />
    </svg>
  );
}

export default SvgCommissionAdd;
